export default __webpack_public_path__ + "static/media/council.a005fc37.svg";